module.exports = __webpack_public_path__ + "static/aboutme-177211b6cc481675d1fa11294d2993bb.png";